import {
  Box,
  CircularProgress,
  Paper,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import QuestionItem from "./QuestionItem";
import { useAppSelector } from "../../Redux/hooks";
import { useParams } from "react-router-dom";
import SurveyActions from "./Survey/SurveyActions";
import React from "react";
import LockStatus from "./LockStatus";
import FormCompletionStatus from "./FormCompletionStatus";

const responseContainer: SxProps = {
  flex: "1",
  minWidth: "1px",
};

const responseWrapper: SxProps = {
  width: "100%",
  p: 2,
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
};

const responseWrapperHeader: SxProps = {
  p: 2,
  borderBottom: "1px solid",
  borderColor: "divider",
  m: -2,
  mb: 2,
};

const QuestionItemWrapper = () => {
  const { surveySlug } = useParams();
  // const scrollToRef = useRef<HTMLDivElement>(null);
  const selectedForm = useAppSelector((state) => state.response.selectedForm);
  const isFormLoading = useAppSelector((state) => state.response.isLoading);
  const questionList = useAppSelector((state) => state.response.questionList);
  const currentCategory = useAppSelector(
    (state) => state.response.currentCategory
  );
  const screeningAttemptId = useAppSelector(
    (state) => state.response.screeningAttemptId
  );
  const showFormVersionBadge =
    currentCategory === "screening" || !!screeningAttemptId;

  // const [idFromQueries, setIdFromQueries] = useState<string>(
  //   sessionStorage.getItem("response-visit-question") || ""
  // );

  // useEffect(() => {
  //   if (idFromQueries && questionList?.length > 0) {
  //     setIdFromQueries("");
  //     scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [questionList, idFromQueries]);

  return (
    <>
      {isFormLoading ? (
        <Stack
          sx={{ flex: 1, height: "100%" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {questionList?.length > 0 && (
            <Box sx={responseContainer}>
              <Paper sx={responseWrapper}>
                <Stack sx={responseWrapperHeader} gap={1}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    flexWrap="wrap"
                  >
                    <Typography fontWeight={"medium"} variant="subtitle1">
                      {selectedForm?.name}
                    </Typography>
                    {showFormVersionBadge &&
                      selectedForm?.formStatus === "active" && (
                        <Typography
                          component="span"
                          variant="caption"
                          fontWeight={600}
                          sx={{
                            px: 1,
                            py: "1px",
                            borderRadius: "999px",
                            bgcolor: "primary.main",
                            color: "primary.contrastText",
                            lineHeight: 1.6,
                          }}
                        >
                          Active screener
                        </Typography>
                      )}
                  </Stack>
                  <Typography
                    variant="body1"
                    fontWeight={"regular"}
                    color="text.secondary"
                  >
                    {selectedForm?.phaseName}
                  </Typography>
                  <FormCompletionStatus selectedForm={selectedForm} />
                  <LockStatus selectedForm={selectedForm} />
                </Stack>

                {questionList
                  .filter(
                    (question) =>
                      question.isVisible && !question.properties.isHidden
                  )
                  .map((question, index) => (
                    <QuestionItem
                      // scrollToRef={
                      //   idFromQueries === question.id ? scrollToRef : null
                      // }
                      key={question.id}
                      index={index}
                      question={question}
                    />
                  ))}
              </Paper>

              {surveySlug && <SurveyActions />}
            </Box>
          )}

          {questionList?.length === 0 && (
            <Stack
              sx={{ flex: 1, height: "100%" }}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography sx={{ fontWeight: "medium" }} color={"primary.main"}>
                No Questions Found
              </Typography>
            </Stack>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(QuestionItemWrapper);
